<div class="liveresults-container">
	<iframe id="liveStats"
		[src]="iframeUrl"
		referrerpolicy="origin-when-cross-origin"
		frameborder="0"
		width="100%" scrolling="no"
		(load)="registerDomain();">
	</iframe>
</div>